var React = require('react');

function MusicLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M40.006 27.071V39.66a1 1 0 001.334.941 7 7 0 00-1.334-13.53zM39.005 25a9 9 0 013.002 17.487 3 3 0 01-4.001-2.826V26a1 1 0 01.999-1zM3.202 27.117A9 9 0 019.006 25a1 1 0 011 1v13.66a3.003 3.003 0 01-2.59 2.97 3 3 0 01-1.412-.143 9 9 0 01-2.802-15.37zm4.804-.046a7 7 0 00-1.336 13.53h.002a1 1 0 001.334-.942V27.071z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.692 10.686a16 16 0 0122.627 0c3.001 3 4.687 6.07 4.687 10.314v8a1 1 0 11-2 0v-8c0-3.713-1.475-6.274-4.1-8.9a14 14 0 00-19.8 0c-2.625 2.626-4.1 5.187-4.1 8.9v8a1 1 0 01-2 0v-8c0-4.244 1.685-7.313 4.686-10.314z","key":1})]);
}

MusicLight.defaultProps = {"viewBox":"0 0 49 48"};

module.exports = MusicLight;

MusicLight.default = MusicLight;
